import React from 'react';
import styled from 'styled-components';
import { Droppable } from 'react-beautiful-dnd';
import BodySiteItem from './BodySiteItem';
import { getBodySiteLabelForValue, getBodySiteHelpForValue } from './ConstBodySiteBtns';

const Container = styled.div`
  // margin: 8px;
  border: 1px solid lightgrey;
  border-radius: 2px;
`;
//padding on the contents allows highlight color to bleed to edge of Container
const Title = styled.div`
  padding: 8px;
  font-weight: bold;
`;
const BodySiteList = styled.div`
  padding: 8px;
`;

export default class BodySiteColumn extends React.Component {
  render() {
    const {
      column,
      bodySites
    } = this.props;

    const hasBodySites = (Array.isArray(bodySites) && (bodySites.length > 0));
    return  (
      <Container>
        <Title>{column.title}</Title>
        { hasBodySites 
          ? 
          <Droppable droppableId={column.id}>
            {/* https://egghead.io/courses/beautiful-and-accessible-drag-and-drop-with-react-beautiful-dnd */}
            {/* render props pattern: child is a function that returns a React component */}
            {/* provided object has a property for droppableProps, need to be applied to BodySiteList */}
            {/* provided.innerRef, which is a function used to supply the DOM node 
                of your component (BodySiteList) to React-beautiful-dnd 
            Note: relying on ref property of styled-component here. 
            */}
            {/* provided.placeholder increases the available space in a Droppable when it's needed */}
            {provided => ( 
              <BodySiteList
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {bodySites.map((bodySite, index) => (
                  <BodySiteItem key={bodySite} 
                    bodySiteId={bodySite}
                    bodySiteLabel={getBodySiteLabelForValue(bodySite)} 
                    bodySiteHelp={getBodySiteHelpForValue(bodySite)}
                    index={index} 
                  />
                ))}
                {provided.placeholder}
              </BodySiteList>
            )}
          </Droppable>
          :
          <BodySiteList>None entered</BodySiteList>
        }
      </Container>
    );
  }
}